import { Pipe, PipeTransform } from '@angular/core';
import { UnitConversionService } from '../services/unit-conversion.service';
import { UnitQuantity, UnitSystem } from '../models/unit.model';

// Impure: the label also depends on the service's densityVariant/massVariant
// signals, which are not pipe arguments — a pure pipe would keep serving the
// cached label after the user switches variant in Project Settings.
@Pipe({
  name: 'unitLabel',
  standalone: true,
  pure: false,
})
export class UnitLabelPipe implements PipeTransform {
  constructor(private unitService: UnitConversionService) {}

  transform(quantity: UnitQuantity, system: UnitSystem): string {
    return this.unitService.getUnitLabel(quantity, system);
  }
}
